import React from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DatavizDoubleTimeChart } from "@radarly/models/dataviz";
import { SearchFragmentDateMetrics } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import Tile from "@radarly/shared/cards/tile";
import DoubleTimeChart from "@radarly/shared/widgets/date-metrics/double-time-chart";
import { CardFragmentProps } from "../model";

const RadarlyMetricsCardDoubleTimeChart = ({
  title,
  fragment,
  project,
  dataviz,
  height,
  onClickItem,
  onGenerateCSV,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<SearchFragmentDateMetrics, DatavizDoubleTimeChart>) => {
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date nowDate={nowDate} fragment={fragment} timezone={timezone} />,
          ]}
        />
      }
      clause={fragment.request.query}
      onGenerateCSV={onGenerateCSV}
      isPNG
    >
      <DoubleTimeChart
        fragment={fragment}
        project={project.id}
        onClickItem={onClickItem}
        dataviz={dataviz}
        forceReload={forceReload}
        nowDate={nowDate}
      />
    </Tile>
  );
};

export default RadarlyMetricsCardDoubleTimeChart;
